import ChecklistConnected from './ChecklistConnected'
export default ChecklistConnected
